import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-label',
  template: `
    <div class="la-label" [ngClass]="{
    'la-label--warning': kind === 'warning',
    'la-label--danger': kind === 'danger',
    'la-label--info': kind === 'info'
    }">
      <la-text [kind]="'caption'">
        <ng-content></ng-content>
      </la-text>
    </div>
  `,
  styles: [`
    @font-face{font-family:NeueHaasGrotDisp-45Light;font-style:normal;font-weight:300;src:url(assets/fonts/NeueHaasGrotDisp-45Light.woff) format("woff")}@font-face{font-family:NeueHaasGrotDisp-55Roman;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasGrotDisp-55Roman.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:400;src:url(assets/fonts/NeueHaasUnicaPro-Regular.woff) format("woff")}@font-face{font-family:NeueHaasUnicaPro;font-style:normal;font-weight:500;src:url(assets/fonts/NeueHaasUnicaPro-Medium.woff) format("woff")}.la-label{background:rgba(54,68,79,.05);border-radius:5px;padding:0 14px;display:inline-block;color:rgba(3,20,34,.4)}.la-label.la-label--info{background:#7ba3df;color:#0a3d89}.la-label.la-label--warning{background:#ffd182;color:#cf8300}.la-label.la-label--danger{background:#fa8091;color:#c5001b}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaLabelComponent {
  private _kind: string;

  get kind(): string {
    return this._kind;
  }

  @Input()
  set kind(kind: string) {
    this._kind = kind;
  }
}
